import { render, staticRenderFns } from "./tab_view.vue?vue&type=template&id=6638fbd7&scoped=true"
import script from "./tab_view.vue?vue&type=script&lang=js"
export * from "./tab_view.vue?vue&type=script&lang=js"
import style0 from "./tab_view.vue?vue&type=style&index=0&id=6638fbd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6638fbd7",
  null
  
)

export default component.exports